<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>Détail de la facture</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0"/>
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="p-6">
                <vs-list>
                    <vs-list-item v-if="data.date" title="La date de facture est supérieur à la date écheance"></vs-list-item>
                    <vs-list-item v-if="data.tt_c" title="La somme du montant de la taxe et celle du montant hors taxe doivent être egale au montant tout taxe compris"></vs-list-item>
                    <vs-list-item v-if="data.contract" title="Le contrat est invalide ou inexistant"></vs-list-item>
                </vs-list>
            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Fermer</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            data:{
                type: Object,
                required: true
            }
        },
        data: () => ({
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
        }),
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
    .border_bill{
        border-color: #EA5455 !important;
    }
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
</style>